import axios from  'axios'
// const baseURL= "http://3.109.148.179/padmahandler/api/"

//const baseURL= "http://3.109.148.179/padmaapitesting/api/"
 //const baseURL = "http://ISST8-PC:1999/api/"
// const baseURL = "http://localhost:8000/api/"
// const baseURL = "http://192.168.1.10:8000/api/"


  const baseURL = "https://live.asktek.net/PadmaIOG_api/api/"
const instance = axios.create({
    baseURL
   
})


export default  {
  instance ,
  baseURL
}
